import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'

const Floors = () => {
  const navigate = useNavigate();
  const [floors, setFloors] = useState([]);
  const [properties, setProperties] = useState([]);
  const [form, setForm] = useState({ floor_name: '', property_id: '' });
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filterPropertyId, setFilterPropertyId] = useState('');


  useEffect(() => {
    getFloors();
    getProperties();
  }, []);

  const getFloors = () => {
    setIsLoading(true);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-floors", {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      if (res.data.status) {
        setFloors(res.data.floors || []);
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
      setIsLoading(false);
    }).catch(err =>{globalErrorHandler(err, navigate);setIsLoading(false);});
  };

  const getProperties = () => {
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-properties", {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      if (res.data.status) {
        setProperties(res.data.properties || []);
      }
    }).catch(err =>globalErrorHandler(err, navigate));
  };

  const openAddModal = () => {
    setForm({ floor_name: '', property_id: '' });
    setIsEdit(false);
    setShowModal(true);
  };

  const openEditModal = (floor) => {
    setForm({ floor_name: floor.floor_name, property_id: floor.property_id });
    setSelectedId(floor.id);
    setIsEdit(true);
    setShowModal(true);
  };

  const validateFloorForm = () => {
  if (!form.property_id || !form.floor_name?.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please select a property and enter a floor name.'
    });
    return false;
  }
  return true;
};

  const saveFloor = () => {

      if (!validateFloorForm()) return;

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/create-floor", form, {
      withCredentials: true
    }).then(res => {
      if (res.data.status) {
        Swal.fire("Success", "Floor added successfully", "success");
        getFloors();
        setShowModal(false);
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    }).catch(err =>globalErrorHandler(err, navigate));
  };

  const updateFloor = () => {

      if (!validateFloorForm()) return;

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-floor", {
      ...form, id: selectedId
    }, {
      withCredentials: true
    }).then(res => {
      if (res.data.status) {
        Swal.fire("Success", "Floor updated successfully", "success");
        getFloors();
        setShowModal(false);
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    }).catch(err =>globalErrorHandler(err, navigate));
  };

  const deleteFloor = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the floor.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-floor", { id }, {
          withCredentials: true
        }).then(res => {
          if (res.data.status) {
            Swal.fire("Deleted", "Floor deleted successfully", "success");
            getFloors();
          } else {
            Swal.fire("Error", res.data.message, "error");
          }
        }).catch(err =>globalErrorHandler(err, navigate));
      }
    });
  };

  return (
    <div className="container-fluid px-4 mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">

      <h3 className="mb-0 flex-grow-1">Floors</h3>
      
  <div className="d-flex align-items-center">
    <select
      className="form-select me-2"
      style={{ minWidth: "200px" }}
      value={filterPropertyId}
      onChange={(e) => setFilterPropertyId(e.target.value)}
    >
      <option value="">All Properties</option>
      {properties.map(p => (
        <option key={p.id} value={p.id}>{p.property_name}</option>
      ))}
    </select>
  </div>
        <Button variant="success" onClick={openAddModal}>Add New Floor</Button>

</div>

      <table className="table table-bordered table-hover shadow-sm">
        <thead className="table-success">
          <tr>
            <th>#</th>
            <th>Floor Name</th>
            <th>Property</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="4">Loading...</td></tr>
          ) : (
            <>
          {floors.filter(f => !filterPropertyId || f.property_id == filterPropertyId)
  .map((floor, index) => {
    const prop = properties.find(p => p.id === floor.property_id);
    return (
      <tr key={floor.id}>
        <td>{index + 1}</td>
        <td>{floor.floor_name}</td>
        <td>{prop?.property_name || floor.property_id}</td>
        <td>
          <Button variant="info" className="me-2" onClick={() => openEditModal(floor)}>Edit</Button>
          <Button variant="danger" onClick={() => deleteFloor(floor.id)}>Delete</Button>
        </td>
      </tr>
    );
  }
  )
}
</>
          )
        }



        </tbody>
      </table>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Floor" : "Add Floor"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Floor Name</label>
            <input
              type="text"
              className="form-control"
              value={form.floor_name}
              onChange={(e) => setForm({ ...form, floor_name: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Property</label>
            <select
              className="form-select"
              value={form.property_id}
              onChange={(e) => setForm({ ...form, property_id: e.target.value })}
            >
              <option value="">Select Property</option>
              {properties.map(prop => (
                <option key={prop.id} value={prop.id}>
                  {prop.property_name}
                </option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={isEdit ? updateFloor : saveFloor}>
            {isEdit ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Floors;
